import { useState, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AppSidebar } from "../components/shared/app-sidebar";
import { ErrorBoundary } from "../components/shared/error-boundary";
import { AutoRefreshIndicator } from "../components/shared/auto-refresh-indicator";
import { AutoRefreshProvider } from "../components/shared/auto-refresh-provider";
import { getSidebarExpandedState } from "../utils/sidebar-state";
import { InlineLoader } from "../components/loaders";

const Dashboard = () => {
  // Initialize sidebar state from localStorage to sync with AppSidebar
  const [sidebarExpanded, setSidebarExpanded] = useState(getSidebarExpandedState);

  return (
    <AutoRefreshProvider>
      <div className="flex relative" role="main">
        <div className="fixed left-0 top-0 h-screen z-30">
          <AppSidebar onExpandChange={setSidebarExpanded} />
        </div>
        <div className={`flex-1 transition-all duration-300 ${sidebarExpanded ? 'ml-60' : 'ml-20'}`}>
          {/*
            The auto-refresh pill floats over the page rather than reserving space, so no screen
            has to make room for it. Centred on the content area (not the viewport) so the sidebar
            does not push it off-centre, and `pointer-events-none` on the rail keeps the strip from
            swallowing clicks on whatever sits beneath it. Renders nothing until the current page
            opts in via `useRegisterAutoRefresh`.
          */}
          <div
            className={`pointer-events-none fixed top-4 right-0 z-40 flex justify-center transition-all duration-300 ${sidebarExpanded ? 'left-60' : 'left-20'}`}
          >
            <AutoRefreshIndicator className="pointer-events-auto shadow-lg" />
          </div>

          <ErrorBoundary>
            <Suspense fallback={
              <div className="flex items-center justify-center min-h-[400px] w-full">
                <InlineLoader size="lg" />
              </div>
            }>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>
    </AutoRefreshProvider>
  );
};

export default Dashboard
